/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/search-red': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.492 2.492c-3.323 3.322-3.323 8.728 0 12.05 2.818 2.819 7.01 3.246 10.284 1.282 0 0 .236-.14.436.059l4.338 4.338c.866.865 2.075 1.071 2.843.304l.132-.132c.767-.768.561-1.978-.304-2.843l-4.347-4.347c-.191-.19-.05-.427-.05-.427 1.964-3.274 1.537-7.466-1.282-10.284-3.322-3.323-8.728-3.323-12.05 0zm10.476 1.574a6.303 6.303 0 010 8.904 6.304 6.304 0 01-8.904 0 6.303 6.303 0 010-8.904 6.303 6.303 0 018.904 0z" _fill="#E25046"/>'
  }
})
